import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Manage from './pages/Manage';
import DebtUser from './pages/DebtUser';
import DebtMe from './pages/DebtMe';
import UserDebtEdit from './pages/UserDebtEdit';
import MeDebtEdit from './pages/MeDebtEdit';
import History from './pages/History';
import KeepAlive from './components/KeepAlive';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="w-8 h-8 border-2 border-dark border-t-transparent rounded-full animate-spin" /></div>;
  return user?.role === 'admin' ? children : <Navigate to="/" replace />;
};

const AppContent = () => (
  <div className="min-h-screen bg-cream font-lao">
    <KeepAlive />
    <Navbar />
    <div className="pt-16 pb-6 px-4 max-w-lg mx-auto">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/manage" element={<AdminRoute><Manage /></AdminRoute>} />
        {/* <Route path="/manage" element={<Manage />} /> */}
        <Route path="/debtors" element={<AdminRoute><DebtUser /></AdminRoute>} />
        <Route path="/debtors/:id" element={<AdminRoute><UserDebtEdit /></AdminRoute>} />
        <Route path="/mydebt" element={<AdminRoute><DebtMe /></AdminRoute>} />
        <Route path="/mydebt/:id" element={<AdminRoute><MeDebtEdit /></AdminRoute>} />
        <Route path="/history" element={<AdminRoute><History /></AdminRoute>} />
      </Routes>
    </div>
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}
